import { render, staticRenderFns } from "./MadagascarIsland.vue?vue&type=template&id=58b60b82&"
import script from "./MadagascarIsland.vue?vue&type=script&lang=js&"
export * from "./MadagascarIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports